

import { AfterViewInit, Component, Inject, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import * as AOS from 'aos';
import Swiper from 'swiper'; 
import { trigger, state, style, transition, animate } from '@angular/animations';
import { MiteventsService } from '../../mitevents.service';
declare var $: any; 
import { DOCUMENT, formatDate, isPlatformBrowser, ViewportScroller } from '@angular/common';
import { Constants } from '../constants';
import { Meta, Title } from '@angular/platform-browser';
import {  AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ThankYouPopupComponent } from '../thank-you-popup/thank-you-popup.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { SeoService } from '../seo.service';

export interface Meetup {
  meetUpGalleryImages: any;
  id: number; // Primary key
  name: string;
  startDate:Date;
  endDate:Date;
  topic: string;
  venue: string;
  organizerName: string;
  createdAt:Date;
  bannerImage:string;
  isExternal:boolean;
  editorContent: string,
  meetupType:boolean,



}

@Component({
  selector: 'app-mitevents',
  templateUrl: './mitevents.component.html',
  styleUrls: ['./mitevents.component.css'],
  animations: [
    trigger('slideToggle', [
      state('open', style({
        height: '*',
        opacity: 1
      })),
      state('closed', style({
        height: '0px',
        opacity: 0
      })),
      transition('closed <=> open', [
        animate('280ms')
      ])
    ])
  ]
})
export class MiteventsComponent implements OnInit, AfterViewInit {
  isPopupVisible = false;
  meetups: Meetup[] = [];
  events: any[] = []; // Assuming you have events array with data
  upcomingEvents: any[] = [];
  ongoingEvents:any[]=[];
  pastEvents: any[] = [];
  subscribeForm!: FormGroup;
  showSuccessPopup: boolean = false;
  message: string = '';
  dialogRef!: MatDialogRef<ThankYouPopupComponent>;
  isBrowser:boolean=false;
  baseUrl=Constants.baseUrl;
  isUpcomingExits:boolean=false;
isPastExists:boolean=false;
isOngoingExists:boolean=false;
loading = false;
  constructor( private miteventsService: MiteventsService,private titleService: Title,private viewportScroller: ViewportScroller,private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,private seoService:SeoService,
    private metaService: Meta, private formBuilder: FormBuilder,  private dialog: MatDialog,  private http: HttpClient , @Inject(PLATFORM_ID) private platformId: any,
 ) {this.isBrowser=isPlatformBrowser(this.platformId);}

  private setTitleAndMetaTags(): void {
    this.titleService.setTitle('Events and Webinars | Maganti IT');

    this.metaService.addTags([
      { name: 'description', content: 'Discover the latest events and meetups in your area! Join like-minded individuals for networking, learning, and fun.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'Events and Webinars | Maganti IT' },
      { property: 'og:url', content: 'https://mitresource.com/mitevents/' },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/mit-eventspage/upcomingevents-1.webp' },
      { property: 'og:description', content: 'Discover the latest events and meetups in your area! Join like-minded individuals for networking, learning, and fun.' },
    ]);
  }
  togglePopup() {
    // Toggle the visibility of the popup
    this.isPopupVisible = !this.isPopupVisible;
  }
  ngOnInit() {
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
{
  "@context": "https://schema.org",
  "@type": "Article",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mitresource.com/mitevents/"
  },
  "headline": "Events and Webinars | Maganti IT",
  "description": "Discover the latest events and meetups in your area! Join like-minded individuals for networking, learning, and fun.",
  "image": "https://mitresource.com/assets/images/mit-eventspage/upcomingevents-1.webp",  
  "author": {
    "@type": "Organization",
    "name": "Maganti IT",
    "url": "https://mitresource.com"
  },  
  "publisher": {
    "@type": "Organization",
    "name": "Maganti IT",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
    }
  },
  "datePublished": "2024-06-28"
}`;
   
    this._renderer2.appendChild(this._document.head, script);
    this.seoService.createLinkForCanonicalURL();
  if(this.isBrowser){     
    AOS.init({disable: 'mobile', duration: 2000, delay: 500,});
  }

   
      this.setTitleAndMetaTags();
    // Call the function to set up event listeners
    // this.handleButtonClick();
    this.loadMeetups();

    this.subscribeForm = this.formBuilder.group({
      subscribeName: ['', [Validators.required, this.nameValidator,Validators.maxLength(30), Validators.minLength(2),Validators.pattern(/^[a-zA-Z]{3,}([ ]?[a-zA-Z]+)*$/)]],
      subscribeEmail: ['', [Validators.required, Validators.email,  Validators.pattern(/^[a-zA-Z][\w\-_.]*[a-zA-Z0-9]@[a-zA-Z]+\.[a-zA-Z]{2,3}$/)]],
    });
  
  }

  ngAfterViewInit(){
    if (this.isBrowser) {
    $('#customers-testimonials').owlCarousel({
      loop: true,
      center: true,
      items: 3,
      margin: 0,
      autoplay: true,
      dots: true,
      autoplayTimeout: 8500,
      smartSpeed: 450,
      onInitialized: (event:any) => {
        this.addAccessibilityToDots(event);
      },
      responsive: {
          0: {
              items: 1
          },
          768: {
              items: 2
          },
          1170: {
              items: 3
          }
      }
  });
    }
  }
  addAccessibilityToDots(event: any) {
    const totalSlides = event.item.count; // Total number of slides
    $('.owl-dot').each((index:any, dot:any) => {
      const slideNumber = index + 1; // Dot corresponds to slide number (index starts at 0)
      const ariaLabel = `Go to slide ${slideNumber}`;
  
      // Set aria-label for the dot
      $(dot).attr('aria-label', ariaLabel);
  
      // Add screen reader text (if necessary)
      $(dot).append(`<span class="sr-only">Slide ${slideNumber}</span>`);
    });
  
    // Optionally, add a description to the active dot (the current slide)
    $('.owl-dot.active').each((index:any, activeDot:any) => {
      $(activeDot).attr('aria-label', `Current slide, slide ${index + 1}`);
      $(activeDot).find('.sr-only').text(`Slide ${index + 1} (active)`);
    });
  }
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
   center:true,
    nav: false,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      740: {
        items: 3
      },
      940: {
        items: 4
      }
    }
   
  }
  loadMeetups() {
    this.miteventsService.getAllMeetups().subscribe(
      (data: Meetup[]) => {
        this.events = data;
        this.splitEvents();
        // console.log( this.meetups," this.meetups");
       
      },
      error => {
        // console.error('Error fetching meetups:', error);
      }
    );
  }
  
  // splitEvents() {
  //   const today = new Date(); 
  //   today.setHours(0, 0, 0, 0); 
  //   this.pastEvents = [];
  //   this.upcomingEvents = [];
  
  //   this.events.forEach(event => {
  //     const startDate = new Date(event.startDate); 
  //     startDate.setHours(0, 0, 0, 0); 
  
  //     if (startDate < today) {
  //       this.pastEvents.push({ ...event, isPastEvent: true });
  //     } else {
  //       this.upcomingEvents.push({ ...event, isPastEvent: false });
  //     }
    
  //   });
  //   if(this.upcomingEvents.length>0){this.isUpcomingExits=true;}else{this.isUpcomingExits=false}
  //   if(this.pastEvents.length>0){this.isPastExists=true;}else{this.isPastExists=false}

  //   this.upcomingEvents.sort((a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime());
  //   this.pastEvents.sort((a, b) => new Date(b.startDate).getTime() - new Date(a.startDate).getTime());


  // }
  splitEvents() {
    const now = new Date(); // Get current date and time
    this.pastEvents = [];
    this.upcomingEvents = [];
    this.ongoingEvents = [];
  
    this.events.forEach(event => {
      const startDate = new Date(event.startDate);
      const endDate = new Date(event.endDate);
  
      // Check if the event has ended
      if (endDate < now) {
        this.pastEvents.push({ ...event, isPastEvent: true });
      } else if (startDate <= now && endDate >= now) {
        this.ongoingEvents.push({ ...event, isOngoing: true });
      } else {
        this.upcomingEvents.push({ ...event, isPastEvent: false });
      }
    });
  
    // Set flags for category existence
    this.isUpcomingExits = this.ongoingEvents.length > 0 || this.upcomingEvents.length > 0;
    this.isPastExists = this.pastEvents.length > 0;
    this.isOngoingExists = this.ongoingEvents.length > 0;
  
    // Sort events
    this.upcomingEvents.sort((a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime());
    this.pastEvents.sort((a, b) => new Date(b.startDate).getTime() - new Date(a.startDate).getTime());
    this.ongoingEvents.sort((a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime());
  }
  


  // Helper method to format date
  formatDateTime(dateTime: string): string {
    return formatDate(dateTime, 'MMM d, y, h:mm a', 'en-US'); // Format date and time
  }
  getImageUrl(bannerImage:string){
if(bannerImage!=null){

return Constants.baseImageUrl + bannerImage;
}else{
  return '../../../assets/images/InternshipPage/business-conference-banner-template-design-for-webinar-marketing-online-class-program-etc-free-vector.jpg'
}
  }
        
  onSubmit(): void {
    if (this.subscribeForm.valid) {
      this.loading = true;
      const formData = new FormData();
      formData.append('Email', this.subscribeForm.value.subscribeEmail); 
      formData.append('Name', this.subscribeForm.value.subscribeName);  
      formData.append('Type', 'subscribe_Form');
  
      // Make the API call
      this.miteventsService.SendSubscriberDetails(formData).subscribe(
        (res: any) => {
  
          // Reset form and open the dialog
          this.subscribeForm.reset();
          this.dialogRef = this.dialog.open(ThankYouPopupComponent, {
            data: {
              title:'Subscription Confirmed!',
              message: 'You’ll now receive exclusive insights and updates on the latest technology trends directly in your inbox. ' }
          });
          setTimeout(() => {
            this.dialog.closeAll();
            this.loading = false; // Hide loader
            
          }, 4000);
        },
        (error) => {
            this.loading = false;
        }
      );
    } else {
      this.subscribeForm.markAllAsTouched();
      this.message = 'Please fix the errors in the form and try again.';
    }
  }
 


  get subscribeNameError(): string {
   const control = this.subscribeForm.get('subscribeName');
    if (control?.hasError('required')) return 'Full name is required';
    if (control?.hasError('invalidName')) return 'First name can accept spaces, alphabet and hyphen only.';
    else if (control?.hasError('minlength')) {
      return 'Full Name must be at least 2 characters long without spaces';
    } else if (control?.hasError('maxlength')) {
      return 'Full Name cannot exceed 30 characters';
    }
    else if (control?.hasError('pattern')){
      return 'Enter valid Name'
    }
    return '';
  }

  get subscribeEmailError(): string {
    const control = this.subscribeForm.get('subscribeEmail');
    if (control?.hasError('required')) return 'Email is required';
    if (control?.hasError('email')) return 'Enter a valid email';
    if (control?.hasError('pattern')) return 'Enter a valid email';
    if (control?.hasError('existingEmail')) return 'Email is already exist.';
    return '';
  }

  nameValidator(control: AbstractControl): ValidationErrors | null {
    const valid = /^[A-Za-z\ ]+$/.test(control.value);
    const value = control.value || '';

    // Check if the value contains spaces or if it's less than 3 characters long
    // if (value.includes(' ') || value.length < 3) {
    //   return { invalidName: true }; 
    // }
    return valid ? null : { invalidName: true };
  }
  
  scrollToSection(sectionId: string): void {
    this.viewportScroller.scrollToAnchor(sectionId);
  }
}
